import { Link } from 'react-router-dom';
import '../assets/styles/Footer.css';

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer text-white py-5 mt-auto">
      <div className="container">
        <div className="row row-cols-1 row-cols-md-4 g-4">
          <div className="col">
            <h3 className="footer-title h5">About Us</h3>
            <p className="footer-text">
              RFF Cargo is a trusted leader in global logistics, delivering innovative freight and supply chain solutions for over 30 years. We are committed to excellence and customer satisfaction.
            </p>
            <Link to="/about" className="footer-link" aria-label="View details about RFF Cargo">
              View Details
            </Link>
          </div>
          <div className="col">
            <h3 className="footer-title h5">Our Offices</h3>
            <div className="footer-text">
              <p className="mb-2">
                <i className="bi bi-geo-alt me-2"></i>
                India Office: Ibrahim Abdi Farah
              </p>
              2nd Floor, Metro House, 12/A, Colaba Causeway, opposite Hotel Majestic Building, 
              Apollo Bandar, Colaba, Mumbai, Maharashtra 400039
              <p className="mb-2">
                <i className="bi bi-telephone me-2"></i>
                <a href="tel:+918427433320" className="footer-link" aria-label="Call India office">+918 427433320</a>
              </p>
              <p className="mb-2">
                <i className="bi bi-envelope me-2"></i>
                <a href="mailto:keitahussein@rffcargo.co.ke" className="footer-link" aria-label="Email India office">keitahussein@rffcargo.co.ke</a>
              </p>
              <hr />
              <p className="mb-2">
                <i className="bi bi-geo-alt me-2"></i>
                Dubai Office: High River Shipping & Cargo LLC Building: Dubai tower 308C Baniyas square
              </p>
              <p className="mb-2">
                <i className="bi bi-telephone me-2"></i>
                <a href="tel:+971563726013" className="footer-link" aria-label="Call Dubai office">+971 56 3726013</a>
              </p>
              <p className="mb-2">
                <i className="bi bi-envelope me-2"></i>
                <a href="mailto:yacubebashir@rffcargo.co.ke" className="footer-link" aria-label="Email Dubai office">yacubebashir@rffcargo.co.ke</a>
              </p>
            </div>
          </div>
          <div className="col">
            <h3 className="footer-title h5">Newsletter</h3>
            <p className="footer-text">
              Subscribe to our newsletter for special offers and logistics updates.
            </p>
            <form>
              <div className="input-group">
                <input
                  type="email"
                  className="form-control footer-input"
                  placeholder="Enter your email"
                  aria-label="Email for newsletter"
                />
                <button type="submit" className="btn btn-footer">Subscribe</button>
              </div>
            </form>
          </div>
          <div className="col">
            <h3 className="footer-title h5">Useful Links</h3>
            <ul className="list-unstyled">
              <li>
                <Link to="/services" className="footer-link" aria-label="View our services">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link" aria-label="Contact us">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="footer-link" aria-label="Read our disclaimer">
                  Disclaimer
                </Link>
              </li>
              <li>
                <Link to="/careers" className="footer-link" aria-label="Explore career opportunities">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="footer-link" aria-label="Read our privacy policy">
                  Privacy Policy
                </Link>
              </li>
              {/* <li>
                <Link to="/locations" className="footer-link" aria-label="View our locations">
                  Locations
                </Link>
              </li> */}
            </ul>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col text-center">
            <p className="footer-copyright">
              © 2025 RFF Cargo. All rights reserved. | Developed by{' '}
              <a
                href="https://jecthub.com"
                className="footer-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit Jecthub website"
              >
                Jecthub
              </a>
            </p>
          </div>
        </div>
      </div>
      <div
        className="back-to-top"
        onClick={scrollToTop}
        role="button"
        title="Back to Top"
        aria-label="Scroll to top"
      >
        <i className="bi bi-arrow-up-circle-fill"></i>
      </div>
      <div className="whatsapp-icon">
        <a
          href="https://wa.me/+254725222600?text=Hello%2C%20I%20need%20help%20with%20a%20shipment%20quote"
          target="_blank"
          rel="noopener noreferrer"
          title="Chat on WhatsApp"
          aria-label="Chat with us on WhatsApp"
        >
          <i className="bi bi-whatsapp"></i>
        </a>
      </div>
    </footer>
  );
}

export default Footer;